import { motion } from "framer-motion";
import { ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "wouter";
import { Navbar } from "@/components/navbar";
import { Footer } from "@/components/footer";
import { EdgeGlow } from "@/components/edge-glow";
import { StorySubmissionForm } from "@/components/stories/story-submission-form";

export default function StorySubmit() {
  return (
    <div className="min-h-screen flex flex-col bg-white text-black dark:bg-zinc-900 dark:text-white w-full">
      <EdgeGlow />
      <Navbar />

      {/* SECTION: header + form with background glow */}
      <section className="relative container mx-auto px-6 py-20 flex-1">
        {/* Background glow (behind everything in this section) */}
        <div className="pointer-events-none absolute inset-0 -z-10 overflow-hidden w-full">
          <svg
            viewBox="0 0 800 800"
            xmlns="http://www.w3.org/2000/svg"
            className="w-full h-full"
            preserveAspectRatio="xMidYMid slice"
            aria-hidden="true"
          >
            <defs>
              {/* brighter pastel gradients */}
              <radialGradient id="g1" cx="50%" cy="50%" r="0%">
                <stop offset="0%" stopColor="#f4caff" stopOpacity="1" />
                <stop offset="35%" stopColor="#b3e7ff" stopOpacity="0.7" />
                <stop offset="65%" stopColor="#ffd1d1" stopOpacity="0.55" />
                <stop offset="100%" stopColor="#ffffff" stopOpacity="0" />
              </radialGradient>

              <radialGradient id="g2" cx="35%" cy="65%" r="40%">
                <stop offset="0%" stopColor="#9fd4ff" stopOpacity="0.9" />
                <stop offset="100%" stopColor="#ffffff" stopOpacity="0" />
              </radialGradient>

              {/* swirl + soften */}
              <filter id="swirl">
                <feTurbulence type="fractalNoise" baseFrequency="0.75" numOctaves="3" seed="14" />
                <feDisplacementMap in="SourceGraphic" scale="320" />
                <feGaussianBlur stdDeviation="28" />
              </filter>

              {/* mask to fade top/bottom so it blends under nav/footer */}
              <linearGradient id="fadeY" x1="0" x2="0" y1="0" y2="1">
                <stop offset="0%" stopColor="white" stopOpacity="0" />
                <stop offset="18%" stopColor="white" stopOpacity="1" />
                <stop offset="82%" stopColor="white" stopOpacity="1" />
                <stop offset="100%" stopColor="white" stopOpacity="0" />
              </linearGradient>
              <mask id="maskY">
                <rect width="100%" height="100%" fill="url(#fadeY)" />
              </mask>
            </defs>

            <g mask="url(#maskY)">
              {/* Layer 1 */}
              <circle cx="400" cy="420" r="360" fill="url(#g1)" filter="url(#swirl)" />
              {/* Layer 2 offset for depth */}
              <circle cx="520" cy="350" r="300" fill="url(#g2)" filter="url(#swirl)" />
            </g>
          </svg>
        </div>

        {/* Header */}
        <motion.div
          className="text-center mb-12"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >

          <div className="mt-6 flex">
            <Link href="/">
              <Button
                variant="outline"
                className="border-teal-500 text-black dark:text-white hover:bg-teal-500 hover:text-black align-left transition-all"
              >
                <ArrowLeft size={16} className="mr-2" />
                Back to Home
              </Button>
            </Link>
          </div>
        </motion.div>

        {/* Form card sits ABOVE the glow */}
        <div className="relative z-10">
          <StorySubmissionForm />
        </div>
      </section>

      {/* normal flow footer (don’t absolutely position) */}
      {/* Full-bleed wrapper */}
      <div className="w-screen">
        <Footer />
      </div>
    </div>
  );
}